import { DocumentNode } from 'graphql';
import { QueryOptions } from '@apollo/client';

import client from '../..';

type ClientQueryOptions = Omit<QueryOptions, 'query'>;

/* 
Make a query to sanity without the use of the useQuery hook. The function matches the signature 
of the useQuery hook. 
*/
const makeClientQuery = (query: DocumentNode, options: ClientQueryOptions) => {
  const sanityClient = client.get();
  // @ts-expect-error - Automatic, Please fix when editing this file
  return sanityClient.query({ query, ...options }).then((response) => response.data);
};

export default makeClientQuery;
